module.exports = __webpack_public_path__ + "img/title.59e8d749.png";